module.exports = __webpack_public_path__ + "img/al.b264ab36.png";